<template>
  <wrld-container :breadcrumbs="this.breadcrumbs">
    <ais-instant-search
      :search-client="search.searchClient"
      index-name="prod_organizations"
    >
      <v-row>
        <v-col sm="9">
          <v-row
            justify="space-between"
          >
            <div class="header-right" style="display: inline-flex;">
              <h2>{{ $tc('companies.companies', 2) }}</h2>
                <ais-search-box>
                  <div slot-scope="{ currentRefinement, isSearchStalled, refine }">
                    <v-text-field
                      prepend-inner-icon="search"
                      :label="$t('search')"
                      class="box-search-box"
                      solo
                      :value="currentRefinement"
                      @input="refine($event)"
                    />
                  </div>

                </ais-search-box>
            </div>
            <div>
              <v-btn
                color=accent
                @click="gotoCreateCompany()"
              >{{$t('companies.create_new_btn')}}</v-btn>
            </div>
          </v-row>

          <!-- Results -->
          <ais-configure
            :hitsPerPage="30"
          />
          <ais-state-results>
            <template slot-scope="{ hits }">
              <div v-if="hits.length > 0">
                <ais-hits>
                  <div slot-scope="{ page, items}">
                    <CompaniesIndexListItem
                      v-for="result in items2"
                      :company="result"
                      :key="result.objectID"
                    />
                  </div>
                </ais-hits>
              </div>
              <div v-else>
                <v-col
                  cols="8"
                  class="pr-3"
                >
                  <span class="title font-weight-light">
                    {{ $t('orders.no_result_search') }}
                  </span>
                </v-col>
              </div>
            </template>
          </ais-state-results>

          <!-- Pagination -->
          <AlgoliaPagination />
        </v-col>

        <!-- Filters -->
        <v-col
          sm="3"
          v-sticky="{ zIndex: 1, stickyTop: 80, disabled: false}"
          class="pl-4 pt-5"
        >
          <!-- Toggle filters -->
          <AlgoliaSwitchFilters :filters="toggleFilters" />

          <!-- Selectable filters -->
          <AlgoliaSelectableFilters :arrFilters="filters" class="pt-3" />

        </v-col>
      </v-row>
    </ais-instant-search>
  </wrld-container>
</template>

<script>
import router from '@/router'
import algoliasearch from 'algoliasearch/lite'
import CompaniesIndexListItem from '@/components/companies/CompaniesIndexListItem'
import AlgoliaSelectableFilters from '@/components/general/AlgoliaSelectableFilters'
import AlgoliaPagination from '@/components/general/AlgoliaPagination'
import AlgoliaSwitchFilters from '@/components/general/AlgoliaSwitchFilters'
import Sticky from '@/directives/sticky.js'

export default {
  name: 'CompaniesIndex',
  components: {
    CompaniesIndexListItem,
    AlgoliaSelectableFilters,
    AlgoliaPagination,
    AlgoliaSwitchFilters
  },
  data () {
    return {
      search: {
        searchClient: algoliasearch(
          '9N5LGLZPRT',
          'e5b8a01d8c6ca064424f71e630360d15'
        )
      },
      filters: [
        { title: this.$i18n.t('companies.labels'), attribute: 'labels' },
        { title: this.$i18n.t('companies.groups'), attribute: 'groups' }
      ],
      toggleFilters: [
        { title: this.$i18n.t('companies.only_verified'), attribute: 'verified' },
        { title: this.$i18n.t('companies.only_my_connections'), attribute: 'verified' }
      ],
      // ------------- MOCKED DATA - BEGIN
      companyIdOfLoggedUser: '10',
      items2: [
        {
          'id': 'd1de2c59-5ab5-442d-8b2f-8c0fdbb4d961',
          'ref': '',
          'name': 'My company',
          'vat': 'CZ123456789',
          'labels': ['industry A', 'product B'],
          'address': {
            'street': 'Purkynova 127',
            'city': 'Brno',
            'postal_code': '61200',
            'country': 'Czech Republic'
          },
          'groups': [],
          'verified': true,
          'conns': ['CUSTOMER'],
          'objectID': '147726232',
          avatar: true
        },
        {
          'id': '20',
          'ref': '',
          'name': 'Not connected',
          'vat': 'CZ123456789',
          'labels': ['industry A', 'product B'],
          'address': {
            'street': 'Purkynova 127',
            'city': 'Brno',
            'postal_code': '61200',
            'country': 'Czech Republic'
          },
          'groups': [],
          'verified': true,
          'conns': ['CUSTOMER'],
          'objectID': '247726232',
          avatar: true
        },
        {
          'id': '30',
          'ref': 'org-ref-3',
          'name': 'Cennected',
          'vat': 'CZ123456789',
          'labels': ['industry A', 'product B'],
          'address': {
            'street': 'Purkynova 127',
            'city': 'Brno',
            'postal_code': '61200',
            'country': 'Czech Republic'
          },
          'groups': ['my-org-group-1', 'my-org-group-2'],
          'verified': true,
          'conns': ['CUSTOMER'],
          'objectID': '347726232',
          avatar: true
        },
        {
          'id': '40',
          'ref': 'org-ref-4',
          'name': 'Managed',
          'vat': 'CZ123456789',
          'labels': ['industry A', 'product B'],
          'address': {
            'street': 'Purkynova 127',
            'city': 'Brno',
            'postal_code': '61200',
            'country': 'Czech Republic'
          },
          'groups': ['my-org-group-1', 'my-org-group-2'],
          'verified': false,
          'conns': ['CUSTOMER'],
          'objectID': '447726232',
          avatar: false
        }
      ]
      // ----------------- MOCKED DATA - END
    }
  },
  computed: {
    breadcrumbs () {
      return [
        { text: 'Wereldo', disabled: false, href: '#/' },
        { text: this.$i18n.tc('companies.companies', 2), disabled: true }
      ]
    }
  },
  methods: {
    gotoCreateCompany () {
      router.push({ name: 'CreateCompany' })
    }
  }
}
</script>

<style lang="scss" scoped>
  h2 {
    padding-left: 25px;
    font-size: 20px;
    font-weight: 500;
    letter-spacing: 0.02em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .header-right {
    display: inline-flex;
    margin-top: 6px;
  }
.filters-panel::-webkit-scrollbar {
  width: 0 !important
}
</style>
